import React, {useState,useRef}  from 'react'
import {localestr,isNumeric,load,loadpay} from '../utils'
import icon from '../icons.svg'; 
import Switch from './Switch'

function PayForm({orderId,ttlsum,pays,consts,userFisSet,action,setFiscal,setModal,setPayData,cashless=null,msg,advance=0}){
    const [val, setVal] = useState(ttlsum-advance||'0') 
    const [cnt, setCnt] = useState(0) 
    const [tab, setTab] = useState(0) 
    const [cert, setCert] = useState(null) 
    const [fisc, setFisc] = useState(-1);
    const [pay, setPay] = useState(pays);
    // const [transactionStep, setTransactionStep] = useState(null)
    const targetRef = useRef()
    const targetClose = useRef()
    //const context=useContext(dataContext)

    let bufer=''
    let buf_tm=null
   
    const newVal=(v)=>{
        let vl=val+''+v
        if(cnt===0) vl=v
        setVal(vl)
        setCnt(1)
    }

    const newKey=(e)=>{
        if(tab===4){
            if(e.key==='Enter' || e.which===13) {
                if(!bufer) return
                setCert(1)
                load('action=getCertInfo&data='+bufer,setCert)
                bufer=''
                if(buf_tm) clearTimeout(buf_tm)
                  buf_tm=null
                return
            }
            bufer+=e.key
            if(!buf_tm) buf_tm=setTimeout(() => bufer='', 1000)
            return
        }
        if(tab) return
        if(e.key==='Enter'){
            action('cash')
            setModal('')
            return
        }
        if(e.key==='Backspace' && val.length){
            let vl=val.substring(0,val.length-1)
            setVal(vl||'0')
        }
        if(!isNumeric(e.key)&&e.key!=='.') return
        let vl=val+''+e.key
        if(cnt===0) {
            vl=e.key
            setCnt(1)
        }
        setVal(vl)
    }

    const cash_pay=()=>{
        if(ttlsum>parseFloat(val)+advance){
            setTab(1)
            return
        }
        closeWnd('cash')
    }
    
    const card_pay = (idx = 0, step = 0, data = null) => {
        // 0 перевірити чи є взагалі якісь термінали
        // 1 перевірити чи є параметри підключення або з'єднання, якщо нема видати повідомлення "переконайтеся...", по ОК зробити позначку на суму і перейти до 8
        // 2 перевірити чи є з'єднання і чи співпадає ІР
        // 3 якщо треба закрити старе з'єднання, або перейти до 4
        // 4 відкрити нове з'єднання, поставити позначку біля суми (мігаючий термінал)
        // 5 почекати доки буде з'єднання, якщо помилка - повторити, пропустити, скасувати
        // 6 оплата
        // 7 перевірити чи пройшла, запам'ятати і позначити оплату, якщо помилка - повторити, пропустити, скасувати
        // 8 якщо оплата не остання перейти до наступної, інакше закрити з'єднання
        // 9 закрити вікно і передати параметри оплати
        //console.log('-----pay------');
        //console.log('idx='+idx);
        //console.log('step='+step);
        //console.log(data,'data')
        //console.log(pay, orderId);

        if (data) {
            if (data.status && data.status === 'pending') {
                return;
            } else if (data.status && data.status === 'ok') {
                return;
            }
        }
        // 0 перевірити чи є взагалі якісь термінали
        if (!step) {
            if (!pay || !orderId) {
                closeWnd('card');
                return;
            }
            if (!consts.constTerminal){
                closeWnd('card');
                return;
            }
            let find_terminal = false;
            for (let i = 0; i < pay.length; i++) {
                if(pay[i].terminals && pay[i].terminals.length){
                    const idx_ = pay[i].terminals.findIndex(el => el.id === consts.constTerminal);
                    if (idx_ !== -1) {
                        find_terminal = true;
                        break;
                    }
                }
            }
            if (!find_terminal) {
                closeWnd('card');
                return;
            }
        }
    
        let newPay = [...pay];
        // 9 закрити вікно і передати параметри оплати
        if (idx > newPay.length - 1) {
            closeWnd('card');
            return;
        }
        // 1 перевірити чи є параметри підключення або з'єднання, якщо нема видати повідомлення "переконайтеся...", по ОК зробити позначку на суму і перейти до 8
        let find_terminal = -1;
        if(newPay[idx].terminals && newPay[idx].terminals.length){
            find_terminal = newPay[idx].terminals.findIndex(el => el.id === consts.constTerminal);
        }
        if (find_terminal === -1) {
            msg(
                newPay[idx].name + "\n" +
                localestr('Сума ') + newPay[idx].sum + "\n" +
                localestr('Переконайтеся, що оплата') + "\n" +
                localestr('успішно здійснена!'),
                localestr('Оплата'),
                [
                    {caption: 'OK',action: () => {let newPay = [...pay];newPay[idx].step = 6;setPay(newPay);setTimeout(() => { card_pay(idx + 1) }, 150);}},
                    { caption: localestr('Скасувати'), action: () => {} }
                ]
            );
            return;
        }
        // 4 відкрити нове з'єднання, поставити позначку біля суми (мігаючий термінал)
        if (!newPay[idx].step) {
            const term_id=newPay[idx].terminals[find_terminal].id
            let j = JSON.stringify({
                order: '' + orderId,
                fiscal: newPay[idx].id,
                amount: newPay[idx].sum,
                merch: newPay[idx].terminals[find_terminal].merchant,
            });
            loadpay('action=pay&term_id='+term_id+'&data='+j, data => card_pay(idx, 1, data))
            newPay[idx].step = 1;
            setPay(newPay);
            return;
        }
        // 5 почекати доки буде з'єднання, якщо помилка - повторити, пропустити, скасувати
        // 6 оплата
        // 7 перевірити чи пройшла, запам'ятати і позначити оплату, якщо помилка - повторити, пропустити, скасувати
        // 8 якщо оплата не остання перейти до наступної, інакше закрити з'єднання
        if (data) {
           if ((data.status && data.status === "error")) {
                msg(localestr('Помилка оплати!') + "\n" + (data.message ?? data.errorDescription), localestr('Помилка'), [
                    {caption: localestr('Повторити спробу'),action: () => {newPay[idx].step = 0;newPay[idx].try=0; setPay(newPay);setTimeout(() => card_pay(idx), 150);}},
                    {caption: localestr('Пропустити'),action: () => {newPay[idx].step = 5;setPay(newPay);setTimeout(() => card_pay(idx + 1), 150);}},
                    {caption: localestr('Скасувати'), action: () => { newPay[idx].step = 0; setPay(newPay); } }
                ])
                return
           } else if ((data.status && data.status === "free")) {
                msg(localestr('Помилка оплати!') + "\n" + localestr('Відсутні дані для оплати!'), localestr('Помилка'), [
                    {caption: localestr('Повторити спробу'),action: () => {newPay[idx].step = 0;newPay[idx].try=0; setPay(newPay);setTimeout(() => card_pay(idx), 150);}},
                    {caption: localestr('Пропустити'),action: () => {newPay[idx].step = 5;setPay(newPay);setTimeout(() => card_pay(idx + 1), 150);}},
                    {caption: localestr('Скасувати'), action: () => { newPay[idx].step = 0; setPay(newPay); } }
                ])
                return
            } else if (data.status === 'awaiting' || data.amount!==newPay[idx].sum || data.merch!==newPay[idx].terminals[find_terminal].merchant) {
                if(newPay[idx].try&&newPay[idx].try>3){
                    msg(localestr('Термінал зайнятий тривалий час!'), localestr('Помилка'), [
                        {caption: localestr('Повторити спробу'),action: () => {newPay[idx].step = 0; newPay[idx].try=0; setPay(newPay);setTimeout(() => card_pay(idx), 150);}},
                        {caption: localestr('Пропустити'),action: () => {newPay[idx].step = 5;setPay(newPay);setTimeout(() => card_pay(idx + 1), 150);}},
                        {caption: localestr('Скасувати'), action: () => { newPay[idx].step = 0; setPay(newPay); } }
                    ])
                    return
                }
                const term_id=newPay[idx].terminals[find_terminal].id
                let j = JSON.stringify({
                    order: '' + orderId,
                    fiscal: newPay[idx].id,
                    amount: newPay[idx].sum,
                    merch: newPay[idx].terminals[find_terminal].merchant,
                });
                setTimeout(() =>loadpay('action=pay&term_id='+term_id+'&data='+j, data => card_pay(idx, 1, data)), 10000)
                newPay[idx].step = 1
                if(!newPay[idx].try) newPay[idx].try=1
                newPay[idx].try++
                setPay(newPay)
                return
            } else if (data.status && data.status === 'connecting') {
                const term_id=newPay[idx].terminals[find_terminal].id
                setTimeout(() =>loadpay('action=status&term_id='+term_id, data => card_pay(idx, 2, data)), 2000)
                newPay[idx].step = 2
                setPay(newPay)
                return;
            } else if (data.status && data.status === 'payment') {
                const term_id=newPay[idx].terminals[find_terminal].id
                setTimeout(() =>loadpay('action=status&term_id='+term_id, data => card_pay(idx, 3, data)), 2000)
                newPay[idx].step = 3
                setPay(newPay)
                return
            } else if (data.status && data.status === 'confirm') {
                const term_id=newPay[idx].terminals[find_terminal].id
                setTimeout(() =>loadpay('action=status&term_id='+term_id, data => card_pay(idx, 4, data)), 2000)
                newPay[idx].step = 4
                setPay(newPay)
                return
            } else if (data.status && data.status === 'success') {
                const term_id=newPay[idx].terminals[find_terminal].id
                newPay[idx].step = 6
                setPay(newPay)
                loadpay('action=del&term_id='+term_id, data => {if(data.status==='OK') card_pay(idx + 1, 0); else loadpay('action=status&term_id='+term_id, data => card_pay(idx, 4, data))})
                //setTimeout(() => card_pay(idx + 1, 0), 1000)
                return;
            }
        }
    }

    const cert_pay=(sum_cert,sum_cash)=>{
        if(!sum_cert) closeWnd('cash')
        else closeWnd('crt_'+(cert.sum).toFixed(2)+'_'+cert.id)
    }
   
    const setFocus=(el)=>{
        if (!el) return
        el.focus()
    }

    const closeWnd=d=>{
        if(targetClose.current) return
        targetClose.current=true
        if(fisc!==-1){
            if(fisc) setFiscal(1)
            else setFiscal(0)
        } else if(consts.constFisCash===3) setFiscal(2-(userFisSet || 2))

        if(d==='card' && (cnt || advance)) action(d+(parseFloat(val)*cnt+advance).toFixed(2))
        else if(d==='cert') action(d+cert.id)
        else action(d)
        setModal('')
    }

    //console.log(pay)

    let cont1=null
    let cont2=null
    let cont3=null
    if(consts) {
        if(consts.constFisCash===3){
            cont1=<div style={{margin:'8px 32px 0 0',display:'flex',justifyContent:'center',alignItems:'center'}}><div style={{fontSize:'large',fontWeight:'bold',flexGrow:'10',padding: '5px'}}>{localestr('Фіскалізація чека')}</div><Switch value={fisc===-1?2-(userFisSet || 2):fisc} chngValue={d=>{setFisc(d===1?0:1)}}/></div>
        }
        if(consts.constFisCard===3){
            cont2=<div style={{margin:'8px 32px 0 0',display:'flex',justifyContent:'center',alignItems:'center'}}><div style={{fontSize:'large',fontWeight:'bold',flexGrow:'10',padding: '5px'}}>{localestr('Фіскалізація чека')}</div><Switch value={fisc===-1?2-(userFisSet || 2):fisc} chngValue={d=>{setFisc(d===1?0:1)}}/></div>
        }
        if(consts.constFisCert===3){
            cont3=<div style={{margin:'8px 32px 0 0',display:'flex',justifyContent:'center',alignItems:'center'}}><div style={{fontSize:'large',fontWeight:'bold',flexGrow:'10',padding: '5px'}}>{localestr('Фіскалізація чека')}</div><Switch value={fisc===-1?2-(userFisSet || 2):fisc} chngValue={d=>{setFisc(d===1?0:1)}}/></div>
        }
    }
    
    let certCont=null
    if(!cert){
        certCont=<>
        <div style={{height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}><div style={{fontSize:'24px',textAlign:'center'}}>Відскануйте сертифікат</div></div>
        <div style={{margin:'15px 0 0 0',display:'flex',justifyContent:'center'}}>
            <div style={{width:'100px',height:'36px',display:'inline-block',verticalAlign:'bottom',borderRadius:'22px'}} className={'key_btn'} onClick={()=>{setModal('')}}><div style={{textAlign:'center',display:'block',lineHeight:'36px'}}>{localestr('Скасувати')}</div></div>
        </div>
        </>
    } else if(cert===1){
        certCont=<>
        <div style={{height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}><div style={{fontSize:'24px',textAlign:'center'}}>Перевірка ...</div></div>
        <div style={{margin:'15px 0 0 0',display:'flex',justifyContent:'center'}}>
            <div style={{width:'100px',height:'36px',display:'inline-block',verticalAlign:'bottom',borderRadius:'22px'}} className={'key_btn'} onClick={()=>{setModal('')}}><div style={{textAlign:'center',display:'block',lineHeight:'36px'}}>{localestr('Скасувати')}</div></div>
        </div>
        </>
    } else if(cert.status==='error'){
        setTimeout(()=>{if(cert.status==='error') setCert(null)}, 20000)
        certCont=<>
        <div style={{height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}><div style={{fontSize:'24px',textAlign:'center'}}>{cert.msg}</div></div>
        <div style={{margin:'15px 0 0 0',display:'flex',justifyContent:'center'}}>
            <div style={{width:'100px',height:'36px',display:'inline-block',verticalAlign:'bottom',borderRadius:'22px'}} className={'key_btn'} onClick={()=>{setModal('')}}><div style={{textAlign:'center',display:'block',lineHeight:'36px'}}>{localestr('Скасувати')}</div></div>
        </div>
        </>
    } else if(cert.status==='Ok'){
        if(cert.sum<ttlsum){
            certCont=<>
            <div style={{height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}><div style={{fontSize:'24px',textAlign:'center'}}>
            {'До оплати '}<b>{ttlsum.toFixed(2)}</b><br/>
            {'Cума сертифікату '}<b>{cert.sum.toFixed(2)}</b><br/>
            {'Не вистачає '}<b>{(ttlsum-cert.sum).toFixed(2)}</b></div></div>
            <div style={{margin:'15px 0 0 0',display:'flex',justifyContent:'center'}}>
                <div style={{width:'150px',display:'inline-block',verticalAlign:'bottom'}} className={'ord_button2 toolBarItem toolBarItem2'} onClick={()=>cert_pay(cert.sum,ttlsum-cert.sum)}><div>{localestr('Готівкою ')+(ttlsum-cert.sum).toFixed(2)}</div></div>
                <div style={{width:'100px',height:'36px',display:'inline-block',verticalAlign:'bottom',borderRadius:'22px'}} className={'key_btn'} onClick={()=>{setModal('')}}><div style={{textAlign:'center',display:'block',lineHeight:'36px'}}>{localestr('Скасувати')}</div></div>
            </div>
            </>
        } else {
            certCont=<>
            <div style={{height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}><div style={{fontSize:'24px',textAlign:'center'}}>
            {'До оплати '}<b>{ttlsum.toFixed(2)}</b><br/>
            {'Cума сертифікату '}<b>{cert.sum.toFixed(2)}</b><br/>
            {'Залишок після оплати '}<b>{(cert.sum-ttlsum).toFixed(2)}</b></div></div>
            {cont3}
            <div style={{margin:'15px 0 0 0',display:'flex',justifyContent:'center'}}>
                <div style={{width:'100px',display:'inline-block',verticalAlign:'bottom'}} className={'ord_button2 toolBarItem toolBarItem2'} onClick={()=>closeWnd('cert')}><div>{localestr('Оплата')}</div></div>
                <div style={{width:'100px',height:'36px',display:'inline-block',verticalAlign:'bottom',borderRadius:'22px'}} className={'key_btn'} onClick={()=>{setModal('')}}><div style={{textAlign:'center',display:'block',lineHeight:'36px'}}>{localestr('Скасувати')}</div></div>
            </div>
            </>
        }
    }
    
    if(consts&&!consts.constCertPay) certCont=null
    //console.log(advance)
    let cardH=null
    if(consts.constCardPay){
        cardH=<div className={tab===1?'tabbuton active':'tabbuton'} role='button' tabIndex={0} onKeyUp={(e)=>{if(e.key === 'Enter') setTab(1)}} onClick={()=>{setTab(1)}}><img style={{width:'32px',height:'32px',margin:'-2px 0px -2px -2px'}} src={icon+'#btn9'} alt='' />{localestr('Картка')}</div>
    }
    let cashlessH=null
    let name=null
    if(cashless){
        name=cashless.name
        cashlessH=<div className={tab===6?'tabbuton active':'tabbuton'} role='button' tabIndex={0} onKeyUp={(e)=>{if(e.key === 'Enter') setTab(6)}} onClick={()=>{setTab(6)}}>{localestr('По перерахунку')}</div>
    }
    let certH=null
    if(consts.constCertPay){
        certH=<div className={tab===4?'tabbuton active':'tabbuton'} role='button' tabIndex={0} onKeyUp={(e)=>{if(e.key === 'Enter') setTab(4)}} onClick={()=>{setTab(4)}}><img style={{width:'32px',height:'32px',margin:'-2px 0px -2px -2px'}} src={icon+'#cert'} alt='' />{localestr('Сертифікат')}</div>
    }
    const stl={width:'48px'}
    const stl2={height:'48px',lineHeight:'48px'}

    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

    function dragMouseDown(e) {
      e = e || window.event;
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }
    
    function elementDrag(e) {
      const elmnt=document.getElementById('modalWndPay')
      e = e || window.event;
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      if (pos2!==0) elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
      if (pos1!==0) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }
  
    function closeDragElement() {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
    }

    function getStep(st){
        if(!st) return null
        if(st===1) return <span style={{fontSize:'small',fontWeight:'bold',color:'#000088'}}>{localestr('в черзі')}</span>
        if(st===2) return <span style={{fontSize:'small',fontWeight:'bold',color:'#000088'}}>{localestr('підключення')}</span>
        if(st===3) return <span style={{fontSize:'small',fontWeight:'bold',color:'#000088'}}>{localestr('очікує оплату')}</span>
        if(st===4) return <span style={{fontSize:'small',fontWeight:'bold',color:'#000088'}}>{localestr('очікує підтвердження')}</span>
        if(st===5) return <span style={{fontSize:'small',fontWeight:'bold',color:'#880000'}}>{localestr('скасовано')}</span>
        if(st===6) return <span style={{fontSize:'small',fontWeight:'bold',color:'#008800'}}>{localestr('оплачено')}</span>

    }

    const to_cash=parseFloat(val)-ttlsum+advance
    const remind=localestr(to_cash<0?'Картою':'Решта')
    const btn_cash=localestr(to_cash<0?'Картою':'Оплата')
    const to_card=ttlsum-parseFloat(val)*cnt-advance
    const card_pays=[]
    let card_pay_sum=parseFloat(val)*cnt+advance
    for(let i=0;i<pay.length;i++){
        const card_sum=parseFloat(pay[i].sum||0)
        const payed=Math.min(card_sum,card_pay_sum)
        card_pay_sum-=payed
        if(card_sum-payed) card_pays.push({name:pay[i].name,sum:(card_sum-payed).toFixed(2),step:pay[i].step})
    }

    return(
        <div className='modal'><div id={'modalWndPay'} className='window' style={{width:'325px',height:'550px'}}>
            <div onMouseDown={dragMouseDown} style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{localestr('Оплата')}</div><div className='closebtn' onClick={()=>{setModal('')}}/></div>
            <div className='content' tabIndex='0' style={{minHeight:'460px',outline:'none'}} ref={el=>{setFocus(el);return targetRef}} onKeyUp={(e)=>{newKey(e)}}>
                <div className='tabpanel' style={{minWidth:'300px'}}>
                    <div className={tab===0?'tabbuton active':'tabbuton'} role='button' tabIndex={0} onKeyUp={(e)=>{if(e.key === 'Enter') setTab(0)}} onClick={()=>{setTab(0)}}><img style={{width:'32px',height:'32px',margin:'-2px 0px -2px -2px'}} src={icon+'#btn10'} alt='' />{localestr('Готівка')}</div>
                    {cardH}{certH}{cashlessH}
                </div>
                <div style={tab===0?{display:'flex',flexDirection:'column',height:'calc(100% - 38px)'}:{display:'none'}}>
                    <div style={{margin:'5px 0 0 0',display:'flex',justifyContent:'center',minHeight:'36px'}}>
                        <div style={{fontSize:'larger',fontWeight:'bold',flexGrow:'10',padding: '4px'}}>{localestr('До оплати')}</div>
                        <div style={{fontSize:'larger',fontWeight:'bold',padding: '4px'}}>{(ttlsum-advance).toFixed(2)}</div>
                    </div>
                    <div style={{display:'flex',justifyContent:'center'}}>
                        <div style={{padding:'7px 4px',fontSize:'larger',fontWeight:'bold',flexGrow:'10'}}>{localestr('Отримано')}</div>
                        <div style={{fontSize:'larger',fontWeight:'bold',padding: '4px'}}>
                        {parseFloat(val).toFixed(2)}
                        </div>
                    </div>
                    <div style={{display:'flex',justifyContent:'center'}}>
                        <div style={{fontSize:'larger',fontWeight:'bold',flexGrow:'10',padding: '4px'}}>{remind}</div>
                        <div style={{fontSize:'larger',fontWeight:'bold',padding: '4px'}}>{(to_cash>0?to_cash:-to_cash).toFixed(2)}</div>
                    </div>
                    <div style={{margin:'5px 0 0 0',display:'flex',justifyContent:'center'}}>
                        <div className='login_btn' title={localestr('1')} onClick={()=>{newVal('1')}} style={stl}><div style={stl2}>1</div></div>
                        <div className='login_btn' title={localestr('2')} onClick={()=>{newVal('2')}} style={stl}><div style={stl2}>2</div></div>
                        <div className='login_btn' title={localestr('3')} onClick={()=>{newVal('3')}} style={stl}><div style={stl2}>3</div></div>
                    </div>
                    <div style={{margin:'0px 0 0 0',display:'flex',justifyContent:'center'}}>
                        <div className='login_btn' title={localestr('4')} onClick={()=>{newVal('4')}} style={stl}><div style={stl2}>4</div></div>
                        <div className='login_btn' title={localestr('5')} onClick={()=>{newVal('5')}} style={stl}><div style={stl2}>5</div></div>
                        <div className='login_btn' title={localestr('6')} onClick={()=>{newVal('6')}} style={stl}><div style={stl2}>6</div></div>
                    </div>
                    <div style={{margin:'0px 0 0 0',display:'flex',justifyContent:'center'}}>
                        <div className='login_btn' title={localestr('7')} onClick={()=>{newVal('7')}} style={stl}><div style={stl2}>7</div></div>
                        <div className='login_btn' title={localestr('8')} onClick={()=>{newVal('8')}} style={stl}><div style={stl2}>8</div></div>
                        <div className='login_btn' title={localestr('9')} onClick={()=>{newVal('9')}} style={stl}><div style={stl2}>9</div></div>
                    </div>
                    <div style={{margin:'0px 0 0 0',display:'flex',justifyContent:'center'}}>
                        <div className='login_btn' style={{...stl,border:'none'}}></div>
                        <div className='login_btn' title={localestr('0')} onClick={()=>{newVal('0')}} style={stl}><div style={stl2}>0</div></div>
                        <div className='login_btn' title={localestr('Стерти')} onClick={()=>{setVal('0')}} style={{...stl,border:'none'}}><div style={stl2}><img style={{width:'20px',height:'20px',margin:'14px'}} src={icon+'#calcx'} alt='' /></div></div>
                    </div>
                    <div style={{flexGrow:'100',minHeight:'1px'}}></div>
                    {cont1}
                    <div style={{margin:'10px 0 0 0',display:'flex',justifyContent:'center'}}>
                        <div style={{width:'100px',display:'inline-block',verticalAlign:'bottom'}} className={'ord_button2 toolBarItem toolBarItem2'} onClick={()=>cash_pay()}><div>{btn_cash}</div></div>
                        <div style={{width:'100px',height:'36px',display:'inline-block',verticalAlign:'bottom',borderRadius:'22px'}} className={'key_btn'} onClick={()=>{setModal('')}}><div style={{textAlign:'center',display:'block',lineHeight:'36px'}}>{localestr('Скасувати')}</div></div>
                    </div>
                </div>
                <div style={tab===1?{display:'flex',flexDirection:'column',height:'calc(100% - 38px)'}:{display:'none'}}>
                    <div style={{minHeight:'233px',fontSize:'larger',marginTop:'-1px',marginLeft:'5px'}}>
                        <p>{localestr('Кількість оплат')} <b>{card_pays.length}</b> <br/>{localestr('на загальну суму')} <b>{to_card.toFixed(2)}</b></p>
                        <ul>
                        {card_pays.map((el,id)=><li key={id}>{el.name} - <b>{el.sum}</b> {(getStep(el.step))}</li>)}
                        </ul>
                        <p style={{textAlign:'center',fontWeight:'bold',color:'#880000'}}>{localestr("Переконайтеся, що оплата")}<br/>{localestr("успішно здійснена!")}</p>
                    </div>
                    <div style={{flexGrow:'100',minHeight:'1px'}}></div>
                    {cont2}
                    <div style={{margin:'15px 0 0 0',display:'flex',justifyContent:'center'}}>
                        <div style={{width:'100px',display:'inline-block',verticalAlign:'bottom'}} className={'ord_button2 toolBarItem toolBarItem2'} onClick={()=>{if(to_card)card_pay(); else cash_pay()}}><div>{localestr('Оплата')}</div></div>
                        <div style={{width:'100px',height:'36px',display:'inline-block',verticalAlign:'bottom',borderRadius:'22px'}} className={'key_btn'} onClick={()=>{setModal('')}}><div style={{textAlign:'center',display:'block',lineHeight:'36px'}}>{localestr('Скасувати')}</div></div>
                    </div>
                </div>
                <div style={tab===4?{display:'flex',flexDirection:'column',height:'calc(100% - 38px)',justifyContent:'center',alignItems:'center'}:{display:'none'}}>
                    {certCont}
                </div>
                <div style={tab===6?{display:'flex',flexDirection:'column',height:'calc(100% - 50px)'}:{display:'none'}}>
                    <div style={{minHeight:'233px',fontSize:'larger',marginTop:'-1px',marginLeft:'5px'}}>
                        <p style={{textAlign:'center',fontWeight:'bold',color:'#880000'}}>{name}</p>
                        <p style={{textAlign:'center'}}>{localestr('Оплата по перерахунку на суму')}</p>
                        <p style={{textAlign:'center',fontWeight:'bold',fontSize:'x-large'}}>{ttlsum.toFixed(2)}</p>
                    </div>
                    <div style={{flexGrow:'100',minHeight:'1px'}}></div>
                    <div style={{margin:'15px 0 0 0',display:'flex',justifyContent:'center'}}>
                        <div style={{width:'100px',display:'inline-block',verticalAlign:'bottom'}} className={'ord_button2 toolBarItem toolBarItem2'} onClick={()=>closeWnd('cashless')}><div>{localestr('Закрити')}</div></div>
                        <div style={{width:'100px',height:'36px',display:'inline-block',verticalAlign:'bottom',borderRadius:'22px'}} className={'key_btn'} onClick={()=>{setModal('')}}><div style={{textAlign:'center',display:'block',lineHeight:'36px'}}>{localestr('Скасувати')}</div></div>
                    </div>
                </div>
            </div>
        </div></div>
    )
}

export default PayForm